import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminLogin from "./Admin/AdminLogin";
import VerifyOTP from "./Admin/VerifyOTP";
import "./App.css";
import Sidebar from "./Sidebar/Sidebar";
import TeamRequests from "./Admin/TeamRequests";
import AdminDashboard from "./Admin/AdminDashboard";
import ViewMissions from "./Admin/ViewMissions";
import MissionEvents from "./Admin/MissionEvents";
import DroneFlyingDetails from "./Admin/DroneFlyingDetails";
import Flights from "./Graphs/Flights";
import ActiveTeams from "./Admin/ActiveTeams";
import PilotVehicles from "./Admin/PilotVehicles";
import AllFlights from "./Admin/AllFlights";
import AllPilotsVehicleshistory from "./Admin/AllPilotsVehicleshistory";
import MissionReplay from "./Admin/MissionReplay";
import SuperadminDashboardTEMP from "./superadmin/SuperadminDashboardTEMP";
import AddAdmin from './superadmin/AddAdmin';
import AdminRegistration from './superadmin/AdminRegistration';
import ViewAllAdmins from './superadmin/ViewAllAdmins';
import UpdatePilotStatus from './Admin/UpdatePilotStatus';
import CompanyDetail from "./superadmin/CompanyDetail";
import PilotDetails from "./Admin/PilotDetails";
import AdminProfile from "./Admin/AdminProfile";
import Chat from "./Messages/Chat";
import VehicleServiceHistory from "./Admin/VehicleServiceHistory";
import PilotDroneMissionQuickSearch from "./Admin/PilotDroneMissionQuickSearch";
import PilotKeyGeneration from "./Admin/PilotKeyGeneration";
import AdminProfileRequests from "./superadmin/AdminProfileRequests";
// import PilotProfileRequests from "./Admin/PilotProfileRequests";

function App() {
  return (
     <BrowserRouter> 
        <Routes>
          <Route path="/" element={<AdminLogin />} />
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/sidebar" element={<Sidebar/>} />
          <Route path="/admin/teams/requests" element={<TeamRequests/>} />
          <Route path="/admin/dashboard" element={<AdminDashboard/>} />
          <Route path='/admin/view/missions' element={<ViewMissions />} />
          <Route path="/admin/mission/events" element={<MissionEvents />} />
          <Route path="/admin/Drone/flying/details" element={<DroneFlyingDetails />} />
          <Route path="/admin/flights" element={<Flights />} />
          <Route path="/admin/teams/active" element={<ActiveTeams />} />
          <Route path="/admin/pilots/vehicles" element={<PilotVehicles />} />
          <Route path="/admin/all-flights" element={<AllFlights />} />
          <Route path="/admin/all/pilots-vehicles/history" element={<AllPilotsVehicleshistory />} />
          <Route path="/admin/mission-replay" element={<MissionReplay />} />
          <Route path="/superadmin/dashboard" element={<SuperadminDashboardTEMP />} />
          <Route path="/superadmin/add-admin" element={<AddAdmin />} />
          <Route path="/admin-register/:link/" element={<AdminRegistration />} />
          <Route path="/superadmin/view-all-admins" element={<ViewAllAdmins />} />
          <Route path="/admin/suspend-pilots" element={<UpdatePilotStatus />} />
          <Route path="/superadmin/company/:companyId" element={<CompanyDetail />} />
          <Route path="/admin/teams/active/pilot-details" element={<PilotDetails />} />
          <Route path="/admin/profile" element={<AdminProfile />} />
          <Route path="/superadmin/profile" element={<AdminProfile />} />
          <Route path="/superadmin/messages" element={<Chat />} />
          <Route path="/admin/messages" element={<Chat />} />
          <Route path="/vehicle-service-history" element={<VehicleServiceHistory />} />
          <Route path="/admin/pilot-drone-quick-search" element={<PilotDroneMissionQuickSearch />} />       
          <Route path="/admin/generate-pilot-key" element={<PilotKeyGeneration />} />     
          <Route path="/superadmin/profile-requests" element={<AdminProfileRequests />} />
          {/* <Route path="/admin/pilot-profile-requests" element={<PilotProfileRequests />} /> */}
          <Route path="/superadmin/notifications" element={<SuperadminDashboardTEMP />} />
          <Route path="/admin/notifications" element={<AdminDashboard />} />
        </Routes>
    </BrowserRouter>
    
  );
}

export default App;